














































import { assignUsersPayment } from '@/api/Agency/agency.api'
import { UserPaymentItem } from '@/api/Agency/agency.interface'
import { User } from '@/api/Auth/auth.interface'
import { getUsers } from '@/api/Users/users.api'
import ActionButton from '@/components/ActionButton.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import CreateDialog from '@/components/CreateDialog.vue'
import UserListItem from '@/components/UserListItem.vue'
import { VueForm } from '@/utils/interfaces'

import Vue, { PropType } from 'vue'
export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
    appAutocomplete: Autocomplete,
    UserListItem,
    appActionButton: ActionButton,
  },
  props: {
    item: Object as PropType<UserPaymentItem>,
  },
  data() {
    return {
      getUsers: getUsers,
      loading: false,
      dialog: false,
      user: null as null | User,
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        if (this.user) {
          this.loading = true
          await assignUsersPayment(this.item.uuid, this.user.uuid)
          this.item.agent = this.user.uuid
          this.item.agent_name = this.user.username
        }
        this.dialog = false
        form.reset()
      } finally {
        this.loading = false
      }
    },
    onAssign() {
      this.dialog = true
    },
  },
})
